import * as React from 'react';
import styles from './dropdown-menu-item.scss';

export interface DropdownItem {
  value: string;
  description: string;
  disabled?: boolean;
  originalItem?: any;
  onClick?: () => void;
}

export interface DropdownMenuItemComponentProps {
  menuItem: DropdownItem;
}

class DropdownMenuItemComponent extends React.Component<DropdownMenuItemComponentProps> {
  private handleOnClick = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    const { disabled = false, onClick } = this.props.menuItem;
    e.preventDefault();
    if (!disabled) {
      onClick();
    }
  };

  public render(): JSX.Element {
    const {
      value,
      disabled,
      description
    } = this.props.menuItem;
    return (
      <li key={value}>
        <button type="button"
          className={`dropdown-item ${disabled ? styles.disabled : ''}`}
          onClick={this.handleOnClick}
        >
          {description}
        </button>
      </li>
    );
  }
}

export const DropdownMenuItem = DropdownMenuItemComponent;
